<template>
  <!-- 大盒子 -->
  <div class="MedicenCata">
    <!-- 主体内容 -->
    <div class="main">
      <!-- left -->
      <!-- right -->
      <div class="main-right" ref="mainRight">
        <div class="main-icon"
             style="display: flex; align-items: center; padding: 8px 10px; background: #fff; border-bottom: 1px solid #ebeef5;">
          <!-- 左侧图标和标题 -->
          <div class="main-icon-a" style="display: flex; align-items: center; margin-right: 15px;">
            <i :class="iconComes"
               style="border-radius: 50%; font-size: 20px; padding: 6px; background-color: #5a5a5a; color: #fff;"></i>
            <span style="font-size: 12px; font-weight: bold; margin-left: 8px; color: #606266;">{{
                CatalogueName
              }}</span>
          </div>

          <!-- 中间区域（所有筛选条件和按钮都在一行） -->
          <div style="display: flex; align-items: center; flex-wrap: nowrap;">
            <!-- 状态下拉 -->
            <!--            <div class="main-icon-b" style="margin-right: 20px;">
                          <span style="font-size: 12px; color: #606266; font-weight: bold;">状态:</span>
                          <el-dropdown @command="handleCommand" trigger="click" style="margin-left: 4px;">
                            <span class="el-dropdown-link">{{ DropDownedName }}<i class="el-icon-down"></i></span>
                            <el-dropdown-menu slot="dropdown">
                              <el-dropdown-item command="d" dropdown>全部</el-dropdown-item>
                              <el-dropdown-item command="c">未作废</el-dropdown-item>
                              <el-dropdown-item command="a">已作废原单</el-dropdown-item>
                              <el-dropdown-item command="b">作废负单</el-dropdown-item>
                            </el-dropdown-menu>
                          </el-dropdown>
                        </div>-->

            <!-- 搜索框 -->
            <div style="display: flex; align-items: center; margin-right: 20px; white-space: nowrap;">
              <span style="font-size: 12px; color: #606266; font-weight: bold; margin-right: 8px;">编号:</span>
              <el-input v-model="queryConditionForm.infno" size="mini" style="width: 200px; margin-top: 17px"
                        @keyup.enter.native="loadData"></el-input>
            </div>

            <div style="display: flex; align-items: center; margin-right: 20px; white-space: nowrap;">
              <span style="font-size: 12px; color: #606266; font-weight: bold; margin-right: 8px;">姓名:</span>
              <el-input v-model="queryConditionForm.patientName" size="mini" style="width: 200px; margin-top: 17px"
                        @keyup.enter.native="loadData"></el-input>
            </div>

            <div class="block">
              <el-date-picker
                  size="mini"
                  v-model="queryConditionForm.timeFrameArr"
                  type="datetimerange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  @change="handleConditionQuery"
                  :picker-options="pickerOptions">
              </el-date-picker>
            </div>

            <!-- 按钮组（直接跟在时间选择器后面） -->
            <div style="display: flex; align-items: center;">
              <el-button
                  v-for="(v,i) in headerBtn"
                  :key="i"
                  :type="v.type"
                  :loading="loading"
                  :icon="v.icon"
                  size="mini"
                  :style="{...v.style, 'margin-left': '6px'}"
                  @click="handClick(i)">
                {{ v.title }}
              </el-button>
            </div>
          </div>
        </div>
        <!-- table -->
        <div class="table">
          <el-table :data="tableData" border @row-dblclick="showJsonReqParamData">
            <el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop"
                             :label="col.name" :render-header="labelHead"
                             :min-width="getColumnWidth(col.label,col.prop,tableData)">
              <template #default="{ row }">
                {{ safeGetMappedValue(col, row) }}
              </template>
            </el-table-column>
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            <el-table-column fixed="right" label="操作" width="230">
              <template slot-scope="scope">
                <div class="editbox" style="text-align: center;">
                  <el-button type="primary" @click="showJsonReqParamData(scope.row)" size="mini">
                    查看参数
                  </el-button>
                </div>
              </template>

            </el-table-column>
          </el-table>
        </div>

        <el-drawer
            :visible.sync="drawer"
            :direction="direction"
            :modal=false
        >
          <el-tabs type="border-card">
            <el-tab-pane label="请求参数">
              <!-- 请求参数搜索框 -->
                <el-input
                    v-model="reqSearchKeyword"
                    placeholder="请输入请求参数搜索关键字"
                    size="mini"
                    @input="handleReqSearch"
                    style="width: 100%; margin-bottom: 10px;"
                ></el-input>
              <div v-if="reqSearchKeyword && !filteredReqParamData" style="padding: 20px; text-align: center; color: #909399;">
                未找到匹配内容
              </div>
              <json-viewer v-else :value="filteredReqParamData || reqParamData" :expand-depth="4" copyable sort></json-viewer>
            </el-tab-pane>
          </el-tabs>

          <el-tabs type="border-card">
            <el-tab-pane label="响应参数">
              <!-- 响应参数搜索框 -->
                <el-input
                    v-model="respSearchKeyword"
                    placeholder="请输入响应参数搜索关键字"
                    size="mini"
                    @input="handleRespSearch"
                    style="width: 100%; margin-bottom: 10px;"
                ></el-input>
              <div v-if="respSearchKeyword && !filteredRespParamData" style="padding: 20px; text-align: center; color: #909399;">
                未找到匹配内容
              </div>
              <json-viewer v-else :value="filteredRespParamData || respParamData" :expand-depth="4" copyable sort></json-viewer>
            </el-tab-pane>
          </el-tabs>
        </el-drawer>
        <el-pagination
            class="fixed-pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[8, 16, 24]"
            :page-size="pageSize"
            :total="totalSize"
            layout="total, sizes, prev, pager, next, jumper"
            background>
          >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAllDept,
  getAllReservation,
  getDoctorList,
  getRegisterType,
  registrationRefund
} from "@/api/reservation/reservationList";
import dayjs from "dayjs";
import {editRegisterList, getActiveList} from "@/api/reservation/reservation";
import {withLoading} from "@/untils/loading";
import {getYbDataPage} from "@/api/ybRecordLog/ybRecordLog";
import JsonViewer from 'vue-json-viewer'
import {docclinicList} from "@/api/ks/ks";

export default {
  components: {
    JsonViewer,
  },
  data() {
    const currentHour = dayjs().hour();
    const currentTimeFrame = currentHour < 12 ? 1 : (currentHour < 18 ? 2 : 3);
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      drawer: false,
      direction: 'rtl',
      reqParamData: null,
      respParamData: null,
      reqSearchKeyword: '',     // 请求参数搜索关键字
      respSearchKeyword: '',    // 响应参数搜索关键字
      filteredReqParamData: null, // 过滤后的请求参数JSON对象
      filteredRespParamData: null, // 过滤后的响应参数JSON对象

      respParamData: {
        "infno": "",
        "msgid": "H53068100065202508201548309180",
        "mdtrtarea_admvs": "530681",
        "insuplc_admdvs": "",
        "recer_sys_code": "007",
        "dev_no": "",
        "dev_safe_info": "",
        "cainfo": "",
        "signtype": "",
        "infver": "V1.0",
        "opter_type": "1",
        "opter": "H53068100065",
        "opter_name": "带土",
        "inf_time": "2025-08-20",
        "fixmedins_code": "H53068100065",
        "fixmedins_name": "加强破面",
        "sign_no": "",
        "input": {
          "data": {
            "mdtrt_cert_type": "",
            "mdtrt_cert_type3": "",
            "mdtrt_cert_no": "",
            "card_sn": "",
            "begntime": "2025-08-20",
            "psn_cert_type": "",
            "certno": "",
            "psn_name": ""
          }
        },
        "info": "9001"
      },
      // 树菜单Props
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      // str
      windowWidth: '', //右侧表格动态宽度
      searchValue: '',
      CatalogueName: '医保记录',
      DropDownedName: '全部',
      state: 0,
      iconComes: 'el-icon-tnzdsj',
      // boolean
      disabled: true,
      getdisabled: true,
      loading: false,
      addModelShow: false, // 新增控制
      showModalVisible: false,
      editModalVisible: false,
      // number
      idx: 0,
      pageNum: 1, //当前页currentPage
      pageSize: 8,
      totalSize: 10, //总条数
      regState: null,
      /* obj */
      addForm: {}, // form表单 新增 *
      editForm: {
        id: null,
        regDepId: null,
        regDoctorId: null,
        regTypeId: null,
        regDate: null,
        timeFrame: currentTimeFrame,
        currentDoctor: null,
        currentDept: null,
      },
      // arr
      data: [],
      userInfo: [],
      tableData: [],
      currentTable: [],
      TypeOption: [
        {id: 1, label: '西药', value: '西药'}, {id: 2, label: '中成药', value: '中成药'},
        {id: 3, label: '卫材', value: '卫材'}, {id: 4, label: '血液', value: '血液'},
        {id: 5, label: '疫苗', value: '疫苗'}, {id: 9, label: '中药', value: '中药'}
      ],
      formType: [], // 表单头部内容
      timeFrameOption: [{id: 1, label: '上午'}, {id: 2, label: '下午'}, {id: 3, label: '晚上'}],
      statusOption: [{id: 0, label: '禁用', value: '禁用'}, {id: 1, label: '可用', value: '可用'}],
      // title右侧按钮
      headerBtn: [
        {search: "search", title: "搜索", type: "success", style: {marginLeft: "-20px"}},
      ],
      docclinicOptions: [],
      feetBtn: [
        // { refesh:"refesh", label:"新增", type:"primary", icon:"el-icon-edit" },
        // { refesh:"refesh", label:"修改", type:"primary", icon:"el-icon-finished" },
        // { refesh:"refesh", label:"删除", type:"primary", icon:"el-icon-document-checked" },
        // { refesh:"refesh", label:"查看", type:"primary", icon:"el-icon-sort" },
        // { refesh:"refesh", label:"打印", type:"primary", icon:"el-icon-printer" },
        // { refesh:"refesh", label:"导出", type:"primary", icon:"el-icon-finished" },
        // { refesh:"refesh", label:"关闭", type:"primary", icon:"el-icon-close" },
      ],
      // title右侧按钮
      payTypeOptions: [{id: 1, label: '现金'}, {id: 2, label: '支付宝'}, {id: 3, label: '微信'},
        {id: 4, label: '银行卡'}, {id: 5, label: '医保'}, {id: 6, label: '优惠支付'},
        {id: 7, label: '健康卡支付'}, {id: 8, label: '聚合支付'}, {id: 9, label: '组合支付'},
      ],
      payStateOptions: [{id: 0, label: '否'}, {id: 1, label: '是'}],
      tableRows: [
        {name: "诊所", prop: "idAndName"}, {name: "患者序号", prop: "patientId"},
        {name: "患者姓名", prop: "patientName"}, {name: "交易编号", prop: "infno"},
        {name: "创建时间", prop: "createTime"}, {name: "更新时间", prop: "updateTime"},
      ],
      regOptions: [],
      doctorOptions: [],
      allDeptOptions: [],
      deptOptions: [],
      roleOptions: [],
      queryConditionForm: {
        infno: '',
        timeFrameArr: [
          dayjs().startOf('month').format('YYYY-MM-DD HH:mm:ss'),  // 当月1号 00:00:00
          dayjs().endOf('month').format('YYYY-MM-DD HH:mm:ss')     // 当月最后一天 23:59:59
        ],
        patientName:''
      },
      // 表单验证规则
      addFormRules: {},
      showForm: {
        createTime: '',
        discountMoney: null,
        docNo: null,
        id: null,
        name: '',
        nullifyReason: '',
        nullifyRegId: null,
        nullifyTime: '',
        nullifyUserId: null,
        optTime: '',
        orderId: null,
        patientId: null,
        payState: '',
        payType: null,
        receivableMoney: null,
        receivedMoney: null,
        regDepId: null,
        regDoctorId: null,
        regMode: null,
        regNum: null,
        regState: null,
        regTime: '',
        regTypeId: null,
        regUserId: null,
        remake: '',
        utyTimeDetailsId: null,
        visitId: null,
        visitState: null,
      },
      elTree: [
        {
          label: '全部', path: '', title: '', icon: 'el-icon-news',
          children: [],
        },
      ],
    };
  },
  computed: {
    currentTimeFrame() {
      const hour = dayjs().hour();
      return hour < 12 ? 1 : (hour < 18 ? 2 : 3);
    }
  },
  async mounted() {
    this.docclinicOptions = this.$store.getters['preload/getClinicListOptions'];
    await this.loadData();
  },
  methods: {
    async getDocclinicList() {
      const res = await docclinicList();
      this.docclinicOptions = res.data.map(item =>{return{
        id: item.id,
        label: item.name
      }})
    },
    // 处理请求参数搜索
    handleReqSearch() {
      if (!this.reqSearchKeyword.trim()) {
        this.filteredReqParamData = null;
        return;
      }

      if (this.reqParamData) {
        // 过滤JSON对象，只保留包含关键字的对象及其子对象
        this.filteredReqParamData = this.filterJsonByKeyword(this.reqParamData, this.reqSearchKeyword);
      }
    },

    // 处理响应参数搜索
    handleRespSearch() {
      if (!this.respSearchKeyword.trim()) {
        this.filteredRespParamData = null;
        return;
      }

      if (this.respParamData) {
        // 过滤JSON对象，只保留包含关键字的对象及其子对象
        this.filteredRespParamData = this.filterJsonByKeyword(this.respParamData, this.respSearchKeyword);
      }
    },

    // 过滤JSON对象，只保留包含关键字的对象及其子对象
    filterJsonByKeyword(obj, keyword) {
      if (!obj || typeof obj !== 'object') return null;
      
      // 处理数组
      if (Array.isArray(obj)) {
        const filteredArray = [];
        for (let i = 0; i < obj.length; i++) {
          const filteredItem = this.filterJsonByKeyword(obj[i], keyword);
          if (filteredItem !== null) {
            filteredArray.push(filteredItem);
          }
        }
        return filteredArray.length > 0 ? filteredArray : null;
      }
      
      // 处理对象
      const filteredObj = {};
      let hasMatch = false;
      
      for (const key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          // 检查键名是否包含关键字
          if (key.toLowerCase().includes(keyword.toLowerCase())) {
            filteredObj[key] = obj[key];
            hasMatch = true;
          } else {
            // 递归检查子对象
            const child = obj[key];
            const filteredChild = this.filterJsonByKeyword(child, keyword);
            if (filteredChild !== null) {
              filteredObj[key] = filteredChild;
              hasMatch = true;
            }
          }
        }
      }
      
      return hasMatch ? filteredObj : null;
    },


    showJsonReqParamData(row) {
      this.reqParamData = JSON.parse(row.reqParam);
      this.respParamData = JSON.parse(row.respParam || '{}');
      this.reqSearchKeyword = '';
      this.respSearchKeyword = '';
      this.filteredReqParamData = null;
      this.filteredRespParamData = null;
      this.drawer = true;
    },

    async getAllDept() {
      const res = await getAllDept()
      this.allDeptOptions = res.data.map(item => {
        return {id: item.id, label: item.deptName}
      })
      console.log(this.allDeptOptions, 'allDeptOptionsallDeptOptionsallDeptOptionsallDeptOptions')
    },

    async handleCancelEditReservatione() {
      await this.loadAllDept();
      await this.handleGetDoctorList();
      this.editForm = Object.assign({}, this.$options.data.call(this).editForm)
      this.editModalVisible = false;
    },
    async editRegister() {
      await withLoading(this, '数据提交中...')(async () => {
        const res = await editRegisterList(this.editForm);
        if (res.code === 200) {
          await this.loadData();
          this.editModalVisible = false;
        } else {
          this.$message.error(res.message)
        }
      });
    },
    async getActiveList2() {
      const res = await getActiveList({
        regTime: this.editForm.regDate,
        type: this.editForm.timeFrame,
        deptId: this.editForm.regDepId,
      });
      this.doctorOptions = res.data.map(item => {
        return {
          id: item.doctorId, label: item.doctorName
        }
      })
    },
    async getActiveList() {
      const res = await getActiveList({
        regTime: this.editForm.regDate,
        type: this.editForm.timeFrame,
      });
      const registertype = res.data.filter(item => item.registertypeId === this.editForm.regTypeId)
      this.deptOptions = registertype
          .filter((dept, index, arr) =>
              arr.findIndex(d => d.deptId === dept.deptId) === index
          ).map(item => ({
            id: item.deptId,
            label: item.deptName,
          }));
      this.editForm.regDoctorId = null;
    },
    editReservation(row) {
      this.editForm.currentDept = row.regDepId;
      this.editForm.currentDoctor = row.regDoctorId;
      this.editForm.id = row.id;
      this.editForm.regTypeId = row.regTypeId;
      this.editForm.regDate = dayjs().format('YYYY-MM-DD');
      this.editForm = {...this.editForm, ...row};
      this.editForm.regDepId = null;
      this.editForm.regDoctorId = null;
      this.getActiveList();
      this.editModalVisible = true;
    },

    async registrationCancellation(row) {
      const confirmResult = await this.$confirm(
          `是否确认作废挂号人 【${row.name}】的挂号订单?`,
          '作废确认',
          {
            confirmButtonText: '确认作废',
            cancelButtonText: '取消',
            type: 'warning'
          }
      )

      if (!confirmResult) return;
      await withLoading(this, '作废处理中...')(async () => {
        const newData = JSON.parse(JSON.stringify(row))
        newData.visitState = 4;
        const res = await editRegisterList(newData);
        if (res.code === 200) {
          await this.loadData();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    async registrationRefund(row) {
      try {
        // 1. 确认弹窗
        const confirmResult = await this.$confirm(
            `是否确认退款挂号人 【${row.name}】的挂号订单?`,
            '退款确认',
            {
              confirmButtonText: '确认退款',
              cancelButtonText: '取消',
              type: 'warning'
            }
        )

        if (!confirmResult) return;
        await withLoading(this, '退款处理中...')(async () => {
          const res = await registrationRefund({
            id: row.id,
            type: [8, 9].includes(row.payType) ? 1 : 2
          });

          // 4. 处理结果
          if (res.code === 200) {
            await this.loadData(); // 刷新数据
          } else {
            this.$message.error(res.message || '退款失败');
          }
        });


      } catch (error) {

      } finally {
      }
    },
    async handleConditionQuery() {
      try {
        const res = await getAllReservation({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          condtion: this.queryConditionForm.name || '',  // name为空时传空字符串
          startTime: this.queryConditionForm.timeFrameArr?.[0] || '',  // 使用可选链更安全
          endTime: this.queryConditionForm.timeFrameArr?.[1] || '',    // 使用可选链更安全
          regState: this.regState ?? null
        });
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = res.data.content.map(item => {
            return {
              ...item,
              payType: parseInt(item.payType),
            }
          });
        } else {
          this.$message.error("系统异常:请联系管理员")
        }
      } catch (error) {
        this.$message.error("系统异常:请联系管理员")
      } finally {

      }
    },

    async handleGetDoctorList() {
      const res = await getDoctorList()
      this.doctorOptions = res.data.map(item => {
        return {id: item.id, label: item.fullName}
      })
    },

    async getRoleList() {
      const res = await getDoctorList()
      this.roleOptions = res.data.map(item => {
        return {id: item.id, label: item.fullName}
      })
      console.log(res, 'getDoctorListgetDoctorList')
    },

    handleCancelShow() {
      this.showForm = {};
      this.showModalVisible = false;
    },


    handleDbShowData(row) {
      console.log(row, 'rowrow')
      this.showForm = row;
      this.handleGetDoctorList();
      this.getRegisterType();
      this.getRoleList();
      this.showModalVisible = true;
    },

    async getRegisterType() {
      if (this.regOptions.length > 0) return;
      const res = await getRegisterType();
      this.regOptions = res.data.map(item => {
        return {label: item.designation, id: item.id}
      })
    },

    async loadAllDept() {
      const res = await getAllDept();

      const departmentNodes = res.data.map(dept => ({
        label: dept.deptName,      // 科室名称（显示文本）
        id: dept.id,           // 科室ID（用于后续查询医生）
      }));

      this.deptOptions = res.data.map(item => {
        return {
          id: item.id, label: item.deptName
        }
      })

      this.elTree = [
        {
          label: '全部',
          path: '',
          icon: 'el-icon-news',
          children: departmentNodes // 将科室作为"全部"的子节点
        }
      ];
    },
    /*
      数据源
    */
    async loadData() {
      const newItem = {
        pageSize: this.pageSize,
        pageNum: this.pageNum,
        patientName:this.queryConditionForm.patientName,
        infno: this.queryConditionForm.infno || '',
        startTime: this.queryConditionForm.timeFrameArr?.[0] || '',
        endTime: this.queryConditionForm.timeFrameArr?.[1] || '',
      }
      try {
        let res = await getYbDataPage(newItem);
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = res.data.content.map(item => {return{
            ...item,
            idAndName:item.clinicId +'-'+ this.docclinicOptions.find(clinic => clinic.id === item.clinicId)?.label
          }})
        } else {
          this.$message.error("系统异常:请联系管理员")
        }
      } catch (error) {
        console.log(error)
        this.$message.error("系统异常:请联系管理员")
      } finally {
      }
    },
    /*
      about tree
    */
    handleNodeClick(data, e) {
      this.loadData()
    },

    // SelectVal to editForm
    // col 里面包含了表头字段和名称，list 是表格数据
    columnWidth(col, list) {
      let prop = col.prop, lab = col.lab;
      let width = 40; // 设定一个最小值
      let maxlenStr = ""; // 最长字符串
      for (let info of list) {
        if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
      }
      width = Math.max(width, len(lab), len(maxlenStr));
      // 表格自带的内边距(20px) 自调
      return width + 12; // 这里加了 12px
      function len(str) {
        // 实际分配长度可根据需要自行调整
        let length = 8;
        for (const char of str + "") {
          // 英文小写字符 8px
          if ("a" <= char && char <= "z") length += 8;
          // 英文大写字符 8px
          else if ("A" <= char && char <= "Z") length += 8;
          // 中文字符 28px
          else if (char >= "\u4e00" && char <= "\u9fa5") length += 32;
          // 其他 8px
          else length += 12;
        }
        return length;
      }
    },

    // 步骤
    handClick(i) {
      // i event
      switch (i) {
        case 0:
          this.loadData();
          break;
      }
    },
    handleCommand(command) {
      this.DropDownedName =
          command === 'c' ? '未作废' :
              command === 'a' ? '已作废原单' :
                  command === 'b' ? '作废负单' :
                      '全部';
      const state =
          command === 'c' ? 0 :
              command === 'a' ? 1 :
                  command === 'b' ? 2 :
                      null;
      this.regState = state !== null ? parseInt(state) : null;
      this.loadData();
    },

    feetHandClick(i) {
      console.log(i)
      switch (i) {
        case 0:

          break;
        case 1:

          break;
        case 2:
          break;
        case 3:

          break;
        case 4:

          break;
        case 5:
          break;
      }
    },

    // 实时宽度
    updateWindowWidth() {
      this.windowWidth = window.innerWidth - 328;
    },


    //分页
    //每页条数改变触发
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    //当前条数改变触发
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    getColumnWidth(label, prop, tableData) {
      const minWidth = 100;
      const padding = 30; // 增加边距缓冲
      const contentList = tableData.map(item => item?.[prop] ?? '');

      // 计算所有内容宽度（包括表头）
      const widths = [...contentList, label].map(text => {
        const str = String(text || '');
        return this.getTextWidth(str) + padding;
      });

      return Math.max(minWidth, ...widths);
    },

    // 精确计算文本宽度（使用Canvas）
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },

    labelHead(h, {column, $index}) {
      let l = column.label.length;
      let f = 12;
      column.minWidth = f * (l + 5); //加上一个文字长度
      return h("div", {class: "table-head", style: {width: "100%"}}, [
        column.label,
      ]);
    },
    safeGetMappedValue(col, row, type) {

      const hiddenProps = new Set([
        'usedfrquId', 'sdoseCnt', 'prdCnt', 'prdDays', 'medcWayId', 'tcmCnt',
        'selfProe', 'skintstRslt', 'remark', 'remarks', 'rxDosCnt',
      ]);

      if (hiddenProps.has(col.prop)) {
        return ''; // 直接返回空字符串，不显示
      }
      // 1. 检查数据有效性
      const rawValue = row[col.prop];
      if (rawValue === null || rawValue === undefined) return ' ';

      // 2. 检查映射数组
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;

      // 3. 执行映射
      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    },
    /*表格合计列计算*/
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];

      // 需要计算的字段配置
      const calcFields = {
        'receivableMoney': '实收金额',
        'receivedMoney': '应收金额',
      };

      columns.forEach((column, index) => {
        // 第一列显示行号（留空）
        if (index === 0) {
          sums[index] = '';
          return;
        }

        // 第二列（剂量单位）显示"合计"文字
        if (index === 1) {
          sums[index] = '合计';
          return;
        }

        // 只处理需要计算的字段
        if (calcFields[column.property]) {
          const total = data.reduce((sum, item) => {
            const value = parseFloat(item[column.property]) || 0;
            return sum + value;
          }, 0);

          // 如果是cnt列，显示为整数，否则保留两位小数
          sums[index] = column.property === 'cnt'
              ? Math.round(total).toString()
              : total.toFixed(2);
        } else {
          // 其他列显示占位符（与图片中的"一"一致）
          sums[index] = '';
        }
      });

      return sums;
    },
  },

}
</script>

<style lang="less" scoped>
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 190px; /* 根据您的导航栏宽度调整 */
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px); /* 减去导航栏宽度 */
  margin: 0 auto;
}

.fixed-pagination .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 8px;
  max-width: 100%;
}
.json-highlight-container {
  background: #f5f5f5;
  padding: 16px;
  border-radius: 4px;
  overflow-x: auto;
  font-family: monospace;
  white-space: pre-wrap;
  word-break: break-all;
}

.json-highlight-container span {
  font-weight: normal;
}

.el-input {
  width: 100%;
}
.json-container {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
}

.json-title {
  padding: 12px 16px;
  background-color: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
  font-weight: bold;
  color: #303133;
}
::v-deep .el-drawer__header {
  position: relative;
  z-index: 1;
  margin-bottom: 0;
  padding: 16px 20px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

/* 确保内容区域不会覆盖标题 */
::v-deep .el-drawer__body {
  padding-top: 60px; /* 留出标题空间 */
  height: calc(100% - 60px);
  overflow: auto;
}
/deep/ .el-dialog__header {
  padding: 18px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 18px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.dialog {
  .showDialog {
    .tabs {
      /deep/ .el-select > .el-input {
        width: 172px;
      }

      /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 172px;
      }

      /deep/ .el-form-item__content {
        display: flex;

        span {
          font-size: 12px;
        }
      }

      .oneLine {
        width: 524px;
        // background-color: indianred;
      }
    }

    /deep/ .el-dialog__title {
      font-size: 15px;
    }

    /deep/ .el-table {
      font-size: 15px;
    }
  }
}


// content
.MedicenCata {
  height: 100%;
  width: 100%;
  // header
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    background-color: #efefef;
    padding: 4px;

    // justify-content: space-evenly;
    // icon
    .header-icon {
      display: flex;
      align-items: center;
    }

    .feetbtn {
      display: flex;
      justify-content: center;
      margin-left: 12px;
    }
  }

  // main
  .main {
    width: 100%;
    display: flex;
    justify-content: space-between;
    // height: 473px; /* 设置父容器的高度 */
    // overflow-y: auto; /* 当内容超出容器高度时显示垂直滚动条 */
    // left

    // right
    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;
      // alert
      .addmessagesBox {
        .tabs {
          /deep/ .el-select > .el-input {
            width: 172px;
          }

          /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 172px;
          }

          /deep/ .el-form-item__content {
            display: flex;

            span {
              font-size: 12px;
            }
          }

          .oneLine {
            width: 524px;
            // background-color: indianred;
          }
        }

        /deep/ .el-dialog__title {
          font-size: 12px;
        }

        /deep/ .el-table {
          font-size: 12px;
        }

      }

      // icon
      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;

        .main-icon-a {
          // width: 240px;
          // background-color: #00557f;
        }

        .main-icon-b {
          margin-left: 20px;

          /deep/ .el-dropdown {
            font-size: 12px;
            cursor: pointer;
          }

          /deep/ .el-dropdown:hover {
            font-weight: bold;
            color: #66b1ff;
          }

          /deep/ .el-icon--right {
            // background-color: #66b1ff;
          }

          /deep/ .el-popper[x-placement^=bottom] {
            margin-top: 0;
          }
        }

        // c
        .main-icon-c {
          display: flex;
          margin-left: 28px;

          /deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b] {
            width: 80%;
          }
        }
      }

      // table
      /deep/ .el-table .cell {
        font-size: 12px;
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div :first-child {
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div {
        text-align: center;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
      }

      .table {

      }
    }
  }

  // addModel
  .addModel {
    margin-left: 12px;

    /deep/ .el-dialog__header {
      padding: 12px;
      line-height: 28px;
      background-color: #007bb0;
    }

    /deep/ .el-dialog__title {
      color: #fff;
      font-size: 12px;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close:hover {
      background-color: brown;
    }

    /deep/ .el-form-item__label {
      font-size: 12px;
    }
  }

  .editModel {
    /deep/ .el-dialog__header {
      padding: 12px;
      line-height: 28px;
      background-color: #007bb0;
    }

    /deep/ .el-dialog__title {
      color: #fff;
      font-size: 12px;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close:hover {
      background-color: brown;
    }

    /deep/ .el-form-item__label {
      font-size: 12px;
    }
  }

  // feet
  .feet {
    padding: 12px;

  }

  // JSON高亮样式
  .json-highlight-container {
    background: #ffffff;
    padding: 16px;
    border-radius: 6px;
    overflow-x: auto;
    font-family: monospace;
    white-space: pre-wrap;
    word-break: break-all;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    border: 1px solid #ebeef5;
    transition: all 0.3s ease;
  }

  .json-highlight-container:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  }

  .json-highlight-container span {
    font-weight: normal;
  }

  // 搜索框样式优化
  .el-input {
    width: 100%;
    margin-bottom: 16px;
  }

  .el-input__inner {
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
  }

  .el-input__inner:focus {
    border-color: #409eff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }

  // 高亮关键字样式
  .json-highlight-container span.highlight {
    background-color: #fff21c;
    color: #000;
    padding: 0 2px;
    border-radius: 2px;
    font-weight: bold;
  }

}
</style>